import DAO from './DAO.js';
import formFieldsService from '../services/formFieldsService';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';
import dataModel from '../models/DataModel';
import OfflineQueue from './queue/OfflineQueue';
import _ from 'lodash';

export const form_field_root = {
  form_field: {},
};

export default class FormFieldsDAO extends DAO {

  constructor(store) {
    super(store, 'form_field');
    this.unsetFormFields = this.unsetFormFields.bind(this);
    this.clearFormFields = this.clearFormFields.bind(this);
  }

  unsetFormFields(id) {
    StoreItemProcessing.deleteItemInStore(this.itemType, id);
  }

  clearFormFields() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  getFormField(formFieldId, options) {
    if (!options) {
      options = { recordDescriptor: { form_field: {} } };
    }
    return this._getItem(formFieldId, formFieldsService.getFormField.bind(this, formFieldId, options), options);
  }

  async updateFormField(formField, completionStepId, options) {
    const normalizedFormField = this.normalizeItem(formField, { store: true, ignoreOnNormalize: ['response', 'config'] });
    dataModel.actionCableConnector.internalUpdate({ type: 'updateStep', step_id: completionStepId }, completionStepId);    
    this.markPending(normalizedFormField);

    if (dataModel.isOffline) {
      this.handleOfflineResponse(formField, completionStepId, 'update', null, options);
      this.throwItemError();
    }
    else {
      return formFieldsService.updateFormField(formField, completionStepId, null, options)
      .then(response => {
        return this.handleResponse(response, formField, completionStepId, options);
      });
    }
  }

  handleResponse(response, denormalizedFormField, completionStepId, options) {
    if (response.error && !response.offline) {
      dataModel.displayHTTPError(denormalizedFormField, response.error, false);
      this.markError(denormalizedFormField);
      return denormalizedFormField;
    }
    else if (response.offline) {
      this.handleOfflineResponse(denormalizedFormField, completionStepId, 'update', null, options);
      this.throwItemError(); 
    }
    else {
      const formField = this.normalizeAndSyncToStore(response);
      this.markDirty(formField, false);
      this.markSynced(formField);
      this.setFormFieldIncompletionStep(denormalizedFormField, completionStepId);
      return this.mapToReturn(this.findItem(formField.id), options);
    }
  }

  setFormFieldIncompletionStep(formField, completionStepId) {
    const completionStep = dataModel.completionCriteriaDAO.findItem(completionStepId);
    if (completionStep) {
      const fieldIndex = completionStep.form_fields.findIndex(csFieldId => csFieldId == formField.id);
      if (fieldIndex < 0) {
        completionStep.form_fields.push(formField.id);
        dataModel.completionCriteriaDAO.setItemInStore(completionStep);
      }
    }
    return completionStep;
  }

  handleOfflineResponse(formField, completionStepId, activity, options) {
    this.markDirty(formField, true);
    OfflineQueue.addQueueItem(this.itemType, activity, { formField: formField, completionStepId, options });
    return formField;
  }
  
  completeOfflineUpdate(queueItem) {
    const formField = queueItem.itemInfo.formField;
    const eventMetadatum = queueItem.itemInfo.eventMetadatum;
    const options = queueItem.itemInfo.options;
    switch (queueItem.operationKey) {
      // TODO: arguments in these calls don't match up and there are unimplemented functions
    case 'update':
      return this.updateFormField(formField, queueItem.itemInfo.completionStepId, eventMetadatum, options);
    default:
      break;
    }
    return true;
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_form_fields, options.toIgnore.formFields, this.unsetFormFields, this.clearFormFields, options);
  }
}



// WEBPACK FOOTER //
// ./src/dao/FormFieldsDAO.js